import {Box, Center, ChakraProvider} from '@chakra-ui/react'
import {config} from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import LogRocket from 'logrocket'
import setupLogRocketReact from 'logrocket-react'
import PlausibleProvider from 'next-plausible'
import {AppProps} from 'next/app'
import {useRouter} from 'next/router'
import React, {useEffect, useState} from 'react'
import ConfettiExplosion from 'react-confetti-explosion'
import 'reflect-metadata'
import {useAsyncEffect} from 'use-async-effect'
import DevRibbon from '../components/Common/DevRibbon'
import {InitMonitorUserLoggedIn} from '../fetchers/auth'
import {sessionStore} from '../stores/session/sessionStore'
import customTheme from '../styles/themes'
import {isDev, isDevOrPreview, isPreview, isProduction} from '../utils/consts'
import {isRouteAdmin, ROUTE_COUNTRIES, ROUTE_ROOT, routeRequiresAuth} from '../utils/Routes'
import useCurrentSimulation from '../utils/useCurrentSimulation'
import useCurrentTodos from '../utils/useCurrentTodos'

config.autoAddCss = false

require('../styles/globals.css')
require('../components/Common/chat.scss')

const MyApp = ({Component, pageProps}: AppProps) => {
  const {} = InitMonitorUserLoggedIn()
  const router = useRouter()
  const [isExploding, setIsExploding] = useState(false)
  useCurrentSimulation()
  useCurrentTodos()
  const user = sessionStore(state => state.user)
  const sessionUser = sessionStore(state => state.sessionUser)
  const loadingSessionUser = sessionStore(state => state.loadingSessionUser)
  const loadingUser = sessionStore(state => state.loadingUser)
  const setProtectedPath = sessionStore(state => state.setProtectedPath)

  useAsyncEffect(async () => {
    if (loadingSessionUser) return
    if (!sessionUser && routeRequiresAuth(router.pathname) && router.pathname !== ROUTE_COUNTRIES) {
      setProtectedPath(router.pathname)
      return router.push(ROUTE_COUNTRIES)
    } else if (!loadingUser && isRouteAdmin(router.pathname) && !user?.isAdmin()) {
      return router.push(ROUTE_ROOT)
    }
  }, [router, loadingSessionUser, sessionUser])

  useEffect(() => {
    if (isPreview) {
      LogRocket.init('xu0ypv/heavnn-dev')
      setupLogRocketReact(LogRocket)
    } else if (!isDev) {
      LogRocket.init('xu0ypv/heavnn-prod')
      setupLogRocketReact(LogRocket)
    }
  }, [])

  useEffect(() => {
    if (!router.pathname.includes('payment')) return
    window.setTimeout(() => {
      setIsExploding(true)
      window.setTimeout(() => {
        setIsExploding(false)
      }, 3500)
    }, 1000)
  }, [router])

  useEffect(() => {
    if ((isPreview || isProduction) && user) {
      LogRocket.identify(user.id, {
        name: user.displayName(),
        email: user.email,
      })
    }
  }, [user])

  return (
    <PlausibleProvider domain='app.heavnn.io'>
      <ChakraProvider theme={customTheme}>
        {isExploding && (
          <Box w='100vw' height='100vh' overflow='hidden' pos='absolute'>
            <Center>
              <ConfettiExplosion />
            </Center>
          </Box>
        )}
        <Component {...pageProps} />
        {isDevOrPreview && <DevRibbon />}
      </ChakraProvider>
    </PlausibleProvider>
  )
}

export default MyApp
